import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiAmazonwebservices,
  SiDocker,
  SiKubernetes,
  SiTerraform,
  SiGooglecloud,
  SiAnsible,
  SiLinux,
  SiPython,
} from "react-icons/si";
import { VscAzure } from "react-icons/vsc";


function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiAmazonwebservices />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <VscAzure />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiGooglecloud />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDocker />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKubernetes />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTerraform />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAnsible />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiLinux />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <SiPython />
      </Col>
    </Row>
  );
}

export default Techstack;
